
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[speciali]",
      function () {
        return require("private-next-pages/s/[speciali].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[speciali]"])
      });
    }
  